<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <div class="content">
          <h3 class="has-text-info">直接拖曳即區塊排序</h3>
        </div>
      </div>
      <div class="level-right">
        <p class="level-item">
          <b-button type="is-primary" @click="onCreate">
            {{ $t('attributes.add') }}
          </b-button>
        </p>
      </div>
    </nav>

    <b-table
      :data="items"
      :loading="loading"
      :mobile-cards="false"
      narrowed
      bordered
      draggable
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        centered
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        :label="$t('attributes.pc') + $t('attributes.display')"
        centered
        v-slot="props"
      >
        <b-switch
          v-model="props.row.pc_show"
          true-value="true"
          false-value="false"
        ></b-switch>
      </b-table-column>

      <b-table-column
        :label="$t('attributes.mobile') + $t('attributes.display')"
        centered
        v-slot="props"
      >
        <b-switch
          v-model="props.row.mobile_show"
          true-value="true"
          false-value="false"
        ></b-switch>
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        <b-input v-model="props.row.name"></b-input>
      </b-table-column>

      <b-table-column field="url" :label="$t('attributes.url')" v-slot="props">
        <b-input v-model="props.row.url"></b-input>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
    <b-field>
      <b-button
        type="is-primary"
        @click="onUpdate"
        style="width: 100%; margin-top: 30px;"
      >
        {{ $t('attributes.update') }}
      </b-button>
    </b-field>
    <b-modal :active.sync="isModelActive" has-modal-card>
      <theme-form :attribute="attribute" @onSend="onSend"></theme-form>
    </b-modal>
  </section>
</template>

<script>
import { HOME_API, HOME_FOOTER_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import ThemeForm from '@/components/home/ThemeForm'

export default {
  name: 'Footer',
  components: { ThemeForm },

  data() {
    const { query } = this.$route

    return {
      loading: false,
      items: [],
      isModelActive: false,
      attribute: 'footer',

      filterStatus: query.status || '',

      draggingRow: null,
      draggingRowIndex: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.getQuery(to.query)
      this.loadItems()
    }

    next()
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      try {
        this.loading = true
        const api = `${HOME_FOOTER_API}`

        const res = await this.axios.get(api)
        const items = res.data.data

        this.items = items.sort((t1, t2) => t1.sort - t2.sort)
      } catch (e) {
        this.items = []

        notifyService.fetch_error('footer', e)
      } finally {
        this.loading = false
      }
    },
    async onUpdate() {
      try {
        this.loading = true
        const api = `${HOME_FOOTER_API}`
        const res = await this.axios.put(api, this.items)
        const items = res.data.data

        this.items = items.sort((t1, t2) => t1.sort - t2.sort)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        this.items = []

        notifyService.update_error(e)
      } finally {
        this.loading = false
      }
    },
    onCreate() {
      this.isModelActive = true
    },
    async onSend(item) {
      try {
        this.loading = true
        const api = `${HOME_API}/theme/create`
        const res = await this.axios.post(api, item)

        if (res.data.message === 'Success') {
          notifyService.success(this.$t('attributes.update_succeed'))
          await this.loadItems()
        } else {
          notifyService.create_error()
        }
        this.isModelActive = false
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.loading = false
      }
    },
    getQuery(query) {
      this.filterStatus = query.status || ''
    },
    updateQuery() {
      const query = {
        status: this.filterStatus
      }

      Object.keys(query).forEach(key => !query[key] && delete query[key])

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
    },
    onFilterStatus() {
      this.updateQuery()
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index

      let items = [...this.items]

      items.splice(this.draggingRowIndex, 1)

      items.splice(droppedOnRowIndex, 0, this.draggingRow)

      this.items = items.map((b, idx) => {
        return { ...b, sort: idx + 1 }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  td {
    vertical-align: middle !important;
  }
}
</style>
